module.exports = __webpack_public_path__ + "static/fonts/Montserrat100.b50f5872.ttf";